// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CartGroupHeader_wrap__DEacH","isFree":"CartGroupHeader_isFree___xrLz"};